import React from 'react';
import { useTranslations } from '../localization/useTranslations';
import { UserInfo } from '../settings/types/User';
import EmailValidationNavigator from '../auth/components/EmailValidationNavigator';
import Tabs from '../components/tabs/Tabs';

interface MyAccountNavigationProps {
  userInfo: UserInfo;
  isUserInfoLoading: boolean;
}

const MyAccountNavigation: React.FC<MyAccountNavigationProps> = ({ userInfo, isUserInfoLoading }) => {
  const translations = useTranslations();

  const { route } = translations;

  const tabs = [
    {
      link: `/${route?.savedArticles}/`,
      class: 'menu-link--saved-articles',
      label: translations?.accountNavigation?.savedArticles ?? 'Saved articles',
      icon: 'bookmark',
    },
    {
      link: `/${route?.followedAuthorsAndTopics}/`,
      class: 'menu-link--followed-authors-topic',
      label: translations?.accountNavigation?.followedAuthorsTopics ?? 'Followed authors and topics',
      icon: 'shortcut',
    },
    {
      link: `/${route?.myNewsletters}/`,
      class: 'menu-link--my-newsletters',
      label: translations?.accountNavigation?.myNewsletters ?? 'My newsletters',
      icon: 'mail',
      hasDividerOnRight: true,
    },
    {
      link: `/${route?.myOrders}/`,
      class: 'menu-link--my-orders',
      label: translations?.accountNavigation?.orders ?? 'My orders',
      icon: '',
    },
    {
      link: `/${route?.subscriptions}/`,
      class: 'menu-link--subscriptions',
      label: translations?.accountNavigation?.subscriptions ?? 'Subscriptions',
      icon: '',
    },
    {
      link: `/${route?.settings}/`,
      class: 'menu-link--settings',
      label: translations?.accountNavigation?.settings ?? 'Settings',
      icon: '',
    },
  ];

  // Skip newsletter tab if windows.country is 'hu'.
  if (window.country === 'hu') {
    tabs.splice(2, 1);
  }

  return (
    <div className="container">
      <div className="my-account-nav">
        {isUserInfoLoading ? (
          <div className="my-account-nav__user-wrapper" style={{ height: '80px' }} />
        ) : (
          <div className="my-account-nav__top-row">
            <div className="my-account-nav__user-wrapper">
              <div className="my-account-nav__avatar-wrapper">
                <img
                  src={userInfo.avatarUrl}
                  alt="user avatar"
                  id="my-account-nav-avatar"
                  className="my-account-nav__avatar"
                />
              </div>

              <div className="my-account-nav__user-info">
                <span className="my-account-nav__greeting small-text">
                  {translations?.myAccountNavigation?.heyThereGreatToSeeYou || 'Hey there, great to see you!'}
                </span>

                <h5 className="my-account-nav__user-name">
                  {userInfo.firstName || userInfo.lastName
                    ? `${userInfo.firstName} ${userInfo.lastName}`
                    : userInfo.email}
                </h5>
                {(userInfo.firstName || userInfo.lastName) && (
                  <span className="my-account-nav__user-email basic-14">{userInfo.email}</span>
                )}
              </div>
            </div>

            <EmailValidationNavigator />
          </div>
        )}

        <Tabs tabs={tabs} fontSize={14} useHashRouting hasBottomBorder />
      </div>
    </div>
  );
};

export default MyAccountNavigation;
